import VuexORM from "@vuex-orm/core";

import Address from "@/models/address";
import Device from "@/models/device";
import Downlink from "@/models/downlink";
import Measure from "@/models/measure";
import Notification from "@/models/notification";
import User from "@/models/user";
import SiteGroup from "@/models/site_group";
import TemperatureCorrection from "@/models/temperature_correction";

const database = new VuexORM.Database();

database.register(Address);
database.register(Device);
database.register(Downlink);
database.register(Measure);
database.register(Notification);
database.register(User);
database.register(SiteGroup);
database.register(TemperatureCorrection);

export default VuexORM.install(database);
